
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Teleport from '@xt/client/mixins/components/teleport.vue'
import PopUserContent from '../../../../components/classhour/pop-content/index.vue'
import UserContentCard from '../../../../components/userContentCard/index.vue'
import type { HomeworkTabs } from '@xt/client/entities/content/types.d'
import type { HomeworkOption } from '@xt/client/entities/course-v2/user-content'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import InfiniteLoading, { type StateChanger } from 'vue-infinite-loading'
import { EnumLoadResult } from '@xt/client/entities/content/controller'

@Observer
@Component({
  components: { Teleport, UserContentCard, PopUserContent, EmptyStatus, InfiniteLoading }
})
export default class MyHomework extends Vue {
  @Ref()
  pop: { showPop: (options: HomeworkOption) => void; hidePop: () => void }

  tabs: Array<{ label: string; key: HomeworkTabs }> = [
    { label: '全部', key: 'all' },
    { label: '已评阅', key: 'reviewed' },
    { label: '未评阅', key: 'unreviewed' }
  ]
  current = 0

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get PageStore() {
    return this.$store.$userContent
  }

  async infiniteHandler($state: StateChanger) {
    const res = await this.PageStore.loadUserHomework(this.tabs[this.current].key)

    if (res === EnumLoadResult.Cancel) {
      console.log('其他异常')
    }

    if (res === EnumLoadResult.Error) {
      $state.error()
    }

    if (res === EnumLoadResult.Loaded) {
      $state.loaded()
    }

    if (res === EnumLoadResult.Complete) {
      if (this.PageStore.homeworkList.length > 0) {
        $state.loaded()
      }
      $state.complete()
    }
  }

  handleSwitchTab(index: number, tabKey: HomeworkTabs) {
    if (index === this.current) return

    window.scrollTo(0, 0)

    this.current = index

    this.PageStore.switchHomeworkTab(tabKey)
  }

  handleClick(id: number) {
    this.pop.showPop({
      type: 'homework',
      homeworkId: id
    })
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
